import Order from "@/entities/order.entity";
import EntityFactory from "@/entities/entity.factory";
import UsecaseFactory from "@/usecases/usecase.factory.js";
const defaultExpectedShippingDateUsecase = UsecaseFactory.create("defaultExpectedShippingDate");

const orderOption = EntityFactory.create("orderOption");
const { getColorCodeBasedOnColorName } = orderOption;
// import { BuddhistName } from "@/entities/order.entity";
// import { SecularName } from "@/entities/order.entity";

const defaultStateMaster = {
  detailInput: {
    sanskritCharacter: null,
    product: null,
    productVariation: null,
    azukariProductName: null,
    azukariProductSize: null,
    quantity: 1,
    sanskritCharacterBack: { id: null, sect: "" },
    secularName: [],
    secularNamePrefix: [],
    secularNameSuffix: {},
    familyEmblem: { name: "" },
    underCharacters: [],
    ageAtDeathPrefix: null,
    ageUnitCharacter: [],
    isDiedCharacterNeeded: null,
    diedCharacter: [],
    buddhistName: [],
    customSanskritCharacterUrl: null,
    customSanskritCharacterBackUrl: null,
    customFamilyEmblemUrl: null,
    isNeededLayoutReply: true,
    expectedShippingDate: null,
    deliveryDate: null,
    signature: null,
    attachments: [],
    fortyNinthMemorialServiceDate: null,
    contractDate: null,
    isSanskritCharacterBackNeeded: null,
    contarctDate: null,
    hostName: [],
  },
};

const customerMaster = {
  name: "",
  zipcode: "",
  address: "",
  tel: "",
  customerNumber: "",
  clientGroup: {},
  deliveryDestination: {},
};

const defaultState = {
  // create or edit
  mode: "create",
  // current step
  currentStep: 0,
  customerInput: { ...customerMaster },
  categoryInput: {},
  productInput: {},
  orderTypeInput: {},
  typographyInput: {},
  detailInput: { ...defaultStateMaster.detailInput },
  order: new Order(),
  orderCustomerInfo: {},
  filterInput: {},
  orderDetailContentInput: {},
  orderId: "",
  setOrderId: "",
  statusInput: "",
  clientGroupInput: {},
  deliveryDestinationInput: {},
  parentOrderIdInput: "",
  filter: false,
  favoriteVariantCharacters: [],
  filteredFavoriteVariantCharacters: [],
  // 自由項目
  customFields: [],
  itemSettings: [],
  defaultExpectedShippingDate: null,
  /** OrderCreate の managedOrders をリロード後に復元するスナップショット */
  managedFamilyPersist: null,
};

const MIND_ALTE_CATEGORY_ID = "31200";

export default {
  namespaced: true,
  state: { ...defaultState },
  getters: {
    order: (state, getters) => {
      const {
        customer,
        status,
        clientGroup,
        deliveryDestination,
        parentOrderId,
        orderDetail,
        customFields,
        itemSettings,
      } = getters;
      const param = {
        customer,
        detail: orderDetail,
        status,
        clientGroup,
        deliveryDestination,
        parentOrderId,
        customFields,
        itemSettings,
      };
      return Order.fromJson(param);
    },
    nextStep: (state, getters) => {
      const { currentStep } = state;
      const { _baseUrl } = getters;
      let url = _baseUrl;

      switch (currentStep) {
        case 0:
          url += "/step2";
          break;
        case 1:
          url += "/step4";
          break;
        case 2:
          url += "/step5";
          break;
        case 3:
          url += "/step6";
          break;
        case 4:
          url += "/revise-character";
          break;
        case 5:
          url += "/step7";
          break;
      }
      return url;
    },
    previousStep: (state, getters) => {
      const { currentStep } = state;
      const { _baseUrl } = getters;
      let url = _baseUrl;

      switch (currentStep) {
        case 1:
          url += "/step1";
          break;
        case 2:
          if (state.parentOrderIdInput) {
            // dont move when creating/updating child order
            url += "/step4";
          } else {
            url += "/step2";
          }
          break;
        case 3:
          url += "/step4";
          break;
        case 4:
          url += "/step5";
          break;
        case 5:
          url += "/step6";
          break;
        case 6:
          url += "/revise-character";
          break;
      }
      return url;
    },
    _baseUrl: state => {
      const { mode, orderId } = state;
      switch (mode) {
        case "create":
          return "/orders/create";
        case "edit":
          return `/orders/${orderId}/edit`;
      }
    },
    customer: state => {
      const customer = { ...state.customerInput };
      // STEP1で必須判定のために追加しているフィールドを除外する
      delete customer.clientGroup;
      delete customer.deliveryDestination;

      return customer;
    },
    status: state => {
      return state.statusInput;
    },
    clientGroup: state => {
      return state.clientGroupInput;
    },
    deliveryDestination: state => {
      return state.deliveryDestinationInput;
    },
    parentOrderId: state => {
      return state.parentOrderIdInput;
    },
    orderDetail: state => {
      const {
        productInput,
        orderTypeInput,
        typographyInput,
        detailInput,
      } = state;
      const {
        product,
        productVariation,
        azukariProductName,
        azukariProductSize,
        quantity,
      } = productInput;

      // const { printType, font, frontColor, backColor } = typographyInput;
      const {
        underCharacters,
        underCharactersPlacement,
        secularNamePrefixPlacement,
        ageAtDeathPrefixPlacement,
        sanskritCharacterOrFamilyEmblem,
        sanskritCharacter,
        sanskritCharacterBack,
        isSanskritCharacterBackNeeded,
        familyEmblem,
        customSanskritCharacterUrl,
        customSanskritCharacterBackUrl,
        customFamilyEmblemUrl,
        secularNamePrefix,
        isDiedCharacterNeeded,
        diedCharacter,
        ageAtDeathPrefix,
        ageUnitCharacter,
        columns = [],
        fortyNinthMemorialServiceDate,
        contractDate,
        deliveryDate,
        isNeededLayoutReply,
        expectedShippingDate,
        signature,
        attachments,
        hostName,
      } = detailInput;

      const orderType = orderTypeInput;
      const adjustedFamilyEmblem = { ...familyEmblem };
      delete adjustedFamilyEmblem.isNeeded;

      const adjustedColumns = columns.map((el, index) => {
        const {
          buddhistName,
          underCharacters,
          secularName,
          isTitleNeeded,
          title,
          isSecularNameSuffixNeeded,
          secularNameSuffix,
          isOldCharacterForDateOfDeathNeeded,
          oldCharacterForDateOfDeath,
          ageAtDeathPrefix,
          ageAtDeath,
          ageUnitCharacter,
          dateOfDeathYear,
          dateOfDeathMonth,
          dateOfDeathDay,
        } = el;

        let dateOfDeath = [];
        try {
          if (dateOfDeathYear) {
            dateOfDeath = [...dateOfDeath, ...dateOfDeathYear];
          }
          if (dateOfDeathMonth) {
            dateOfDeath = [...dateOfDeath, ...dateOfDeathMonth];
          }
          if (dateOfDeathDay) {
            dateOfDeath = [...dateOfDeath, ...dateOfDeathDay];
          }
        } catch (err) {
          console.log(err);
        }

        return {
          order: index + 1,
          // TODO テキストが、オブジェクトか
          buddhistName: buddhistName,
          // // TODO
          // points: [
          //   {
          //     character: "-",
          //     imageUrl: "",
          //     order: 0
          //   }
          // ],
          underCharacters: underCharacters,
          // secularName: SecularName.toObject(secularName) || "",
          secularName: secularName,
          isTitleNeeded,
          title,
          isSecularNameSuffixNeeded,
          secularNameSuffix: secularNameSuffix || {},
          dateOfDeath,
          dateOfDeathYear,
          dateOfDeathMonth,
          dateOfDeathDay,
          isOldCharacterForDateOfDeathNeeded,
          oldCharacterForDateOfDeath,
          ageAtDeathPrefix: ageAtDeathPrefix,
          ageAtDeath: ageAtDeath,
          ageUnitCharacter: ageUnitCharacter,
        };
      });

      return {
        product,
        productVariation,
        azukariProductName,
        azukariProductSize,
        quantity,
        orderType:
          orderType && orderType.nameCount
            ? { type: orderType.type, nameCount: orderType.nameCount }
            : null,
        layout: orderTypeInput ? orderTypeInput.layout : null,
        typography:
          typographyInput && typographyInput.printType
            ? {
              printType: typographyInput.printType,
              font: typographyInput.font,
              textColorFront: typographyInput.frontColor,
              textColorBack: typographyInput.backColor,
            }
            : null,
        underCharacters,
        underCharactersPlacement,
        secularNamePrefixPlacement,
        ageAtDeathPrefixPlacement,
        sanskritCharacterOrFamilyEmblem,
        sanskritCharacter,
        familyEmblem: adjustedFamilyEmblem,
        sanskritCharacterBack, // 裏梵字,
        isSanskritCharacterBackNeeded, // 裏梵字フラグ
        customSanskritCharacterUrl, // ユーザー選択梵字
        customSanskritCharacterBackUrl, // ユーザー選択裏梵字
        customFamilyEmblemUrl, // ユーザー選択家紋
        secularNamePrefix: secularNamePrefix,
        isDiedCharacterNeeded,
        diedCharacter: diedCharacter || [],
        ageAtDeathPrefix,
        ageUnitCharacter,
        columns: adjustedColumns,
        fortyNinthMemorialServiceDate: fortyNinthMemorialServiceDate,
        contractDate: contractDate,
        deliveryDate: deliveryDate,
        isNeededLayoutReply,
        expectedShippingDate,
        signature,
        attachments: attachments || [],
        hostName: hostName || [],
      };
    },
    frontColor: state => {
      const { frontColor } = state.typographyInput;
      return createColorObject(frontColor);
    },
    backColor: state => {
      const { backColor } = state.typographyInput;
      return createColorObject(backColor);
    },
    isEditMode: state => {
      return state.mode === "edit";
    },
    getFavoriteVariantCharacters: state => state.favoriteVariantCharacters,
    getFilteredFavoriteVariantCharacters: state => state.filteredFavoriteVariantCharacters,
    isMindAlte: state => {
      const categoryId = state.categoryInput.id;
      return categoryId === MIND_ALTE_CATEGORY_ID;
    },
    customFields: state => {
      return state.customFields;
    },
    itemSettings: state => {
      return state.itemSettings;
    },
  },
  mutations: {
    set (state, user) {
      Object.keys(user).map(key => {
        state[key] = user[key];
      });
    },
    setMode (state, mode) {
      state.mode = mode;
    },
    setChildOrderForm (state, input) {
      const {
        parentOrderId,
        status,
        customer,
        clientGroup,
        deliveryDestination,
        customFields,
        detail,
      } = input;
      const {
        product,
        productVariation,
        azukariProductName,
        azukariProductSize,
        quantity,
        typography,
        expectedShippingDate,
        fortyNinthMemorialServiceDate,
        contractDate,
        deliveryDate,
        signature,
        attachments,
      } = detail;

      // customer information
      state.customerInput = {
        ...customer,
        clientGroup: clientGroup || {},
        deliveryDestination: deliveryDestination || {},
      };

      // customFields information
      state.customFields = customFields;

      // category information
      state.categoryInput = product ? product.category : {};

      // category information
      state.productInput = {
        product,
        productVariation,
        azukariProductName,
        azukariProductSize,
        quantity,
      };

      // print type information
      state.typographyInput = typography
        ? {
          printType: typography.printType,
          font: typography.font,
          frontColor: typography.textColorFront,
          backColor: typography.textColorBack,
        }
        : {};

      // detail information
      state.detailInput.fortyNinthMemorialServiceDate = fortyNinthMemorialServiceDate;
      state.detailInput.contractDate = contractDate;
      state.detailInput.deliveryDate = deliveryDate;
      state.detailInput.expectedShippingDate = expectedShippingDate;
      state.detailInput.signature = signature || null;

      if (attachments) {
        state.detailInput.attachments = attachments;
      }

      state.statusInput = status.code;
      state.clientGroupInput = clientGroup || {};
      state.deliveryDestinationInput = deliveryDestination || {};
      state.parentOrderIdInput = parentOrderId;
    },
    setOrderForm (state, input) {
      const {
        customer,
        customFields,
        detail,
        status,
        clientGroup,
        deliveryDestination,
        parentOrder,
      } = input;
      const {
        familyEmblem,
        customFamilyEmblemUrl,
        customSanskritCharacterUrl,
        customSanskritCharacterBackUrl,
        product,
        productVariation,
        azukariProductName,
        azukariProductSize,
        quantity,
        layout,
        typography,
        underCharacters,
        underCharactersPlacement,
        secularNamePrefixPlacement,
        ageAtDeathPrefixPlacement,
        sanskritCharacterOrFamilyEmblem,
        sanskritCharacter,
        sanskritCharacterBack,
        secularNamePrefix,
        diedCharacter,
        isDiedCharacterNeeded,
        ageAtDeathPrefix,
        ageUnitCharacter,
        isNeededLayoutReply,
        expectedShippingDate,
        columns,
        fortyNinthMemorialServiceDate,
        contractDate,
        deliveryDate,
        signature,
        attachments,
        hostName,
      } = detail;

      // customer information
      state.customerInput = {
        ...customer,
        clientGroup: clientGroup || {},
        deliveryDestination: deliveryDestination || {},
      };

      // customFields information
      state.customFields = customFields;

      // category information
      state.categoryInput = product ? product.category : {};

      // category information
      state.productInput = {
        product,
        productVariation,
        azukariProductName,
        azukariProductSize,
        quantity,
      };

      // order type information
      state.orderTypeInput = detail.orderType
        ? {
          type: detail.orderType.type,
          nameCount: detail.orderType.nameCount,
          layout,
        }
        : {};

      // print type information
      state.typographyInput = typography
        ? {
          printType: typography.printType,
          font: typography.font,
          frontColor: typography.textColorFront,
          backColor: typography.textColorBack,
        }
        : {};

      // detail information
      state.detailInput = {
        underCharacters,
        underCharactersPlacement: "CENTER",
        secularNamePrefixPlacement: "CENTER",
        ageAtDeathPrefixPlacement: "CENTER",
        sanskritCharacterOrFamilyEmblem: null,
        sanskritCharacter: null,
        familyEmblem: null,
        sanskritCharacterBack: null,
        customSanskritCharacterUrl: null,
        customSanskritCharacterBackUrl: null,
        customFamilyEmblemUrl: null,
        // isSecularNameSuffixNeeded: null,
        // secularNameSuffix: null,
        secularNamePrefix: null,
        diedCharacter: null,
        ageAtDeathPrefix: null,
        fortyNinthMemorialServiceDate: fortyNinthMemorialServiceDate,
        contractDate: contractDate,
        deliveryDate: deliveryDate,
        signature: signature || null,
        attachments: null,
        hostName: [],
      };

      if (sanskritCharacterOrFamilyEmblem) {
        state.detailInput.sanskritCharacterOrFamilyEmblem = sanskritCharacterOrFamilyEmblem;
      }

      // state.detailInput.isSecularNameSuffixNeeded = isSecularNameSuffixNeeded;

      state.detailInput.isDiedCharacterNeeded = isDiedCharacterNeeded;

      if (sanskritCharacter) {
        state.detailInput.sanskritCharacter = sanskritCharacter;
      }

      if (familyEmblem) {
        state.detailInput.familyEmblem = {
          isNeeded: !!familyEmblem.name,
          name: familyEmblem.name,
          imageUrl: familyEmblem.imageUrl,
          imageUrlForTablet: familyEmblem.imageUrlForTablet,
        };
      }
      if (sanskritCharacterBack) {
        state.detailInput.sanskritCharacterBack = sanskritCharacterBack;
      }
      // 裏梵字のフロントの設定フラグ
      state.detailInput.isSanskritCharacterBackNeeded =
        sanskritCharacterBack || customSanskritCharacterBackUrl;

      state.detailInput.customSanskritCharacterUrl = customSanskritCharacterUrl;
      state.detailInput.customSanskritCharacterBackUrl = customSanskritCharacterBackUrl;
      state.detailInput.customFamilyEmblemUrl = customFamilyEmblemUrl;
      state.detailInput.secularNamePrefix = secularNamePrefix;
      state.detailInput.underCharactersPlacement = underCharactersPlacement;
      state.detailInput.secularNamePrefixPlacement = secularNamePrefixPlacement;
      state.detailInput.ageAtDeathPrefixPlacement = ageAtDeathPrefixPlacement;

      // if (secularNameSuffix) {
      //   state.detailInput.secularNameSuffix = secularNameSuffix;
      // }

      if (diedCharacter) {
        state.detailInput.diedCharacter = diedCharacter;
      }

      if (ageAtDeathPrefix) {
        state.detailInput.ageAtDeathPrefix = ageAtDeathPrefix;
      }

      if (attachments) {
        state.detailInput.attachments = attachments;
      }

      columns.map(o => {
        let isYear = true;
        let isMonth = false;
        let isDay = false;
        const dateOfDeathYear = [];
        const dateOfDeathMonth = [];
        const dateOfDeathDay = [];

        o.dateOfDeath.map(char => {
          if (isYear && isMonth && isDay) {
            dateOfDeathDay.push(char);
          } else if (isYear && isMonth) {
            dateOfDeathMonth.push(char);
          } else if (isYear) {
            dateOfDeathYear.push(char);
          }
          if (char.character === "年") {
            isMonth = true;
          }
          if (char.character === "月") {
            isDay = true;
          }
        });
        o.dateOfDeathYear = dateOfDeathYear;
        o.dateOfDeathMonth = dateOfDeathMonth;
        o.dateOfDeathDay = dateOfDeathDay;
      });

      state.detailInput = {
        ...state.detailInput,
        ...{
          ageUnitCharacter,
          isNeededLayoutReply,
          expectedShippingDate,
          columns: columns,
          fortyNinthMemorialServiceDate,
          contractDate,
          deliveryDate,
        },
      };

      if (hostName) {
        state.detailInput.hostName = hostName;
      }

      state.statusInput = status.code;
      state.clientGroupInput = clientGroup || {};
      state.deliveryDestinationInput = deliveryDestination || {};
      state.parentOrderIdInput = parentOrder ? parentOrder.id : null;
    },
    setCustomerInput (state, input) {
      state.customerInput = { ...input };
    },
    setCategoryInput (state, input) {
      state.categoryInput = { ...input };
    },
    setProductInput (state, input) {
      state.productInput = { ...input };
    },
    setOrderTypeInput (state, input) {
      state.orderTypeInput = { ...input };
    },
    setTypographyInput (state, input) {
      state.typographyInput = { ...input };
    },
    setDetail (state, input) {
      state.detailInput = { ...input };
    },
    updateDetail (state, input) {
      state.detailInput = { ...state.detailInput, ...input };
    },
    updateExpectedShippingDate (state, input) {
      state.detailInput.expectedShippingDate = input;
    },
    updateDefaultExpectedShippingDate (state, input) {
      state.defaultExpectedShippingDate = input;
    },
    setCurrentStep (state, step) {
      state.currentStep = step;
    },
    orderCustomerInfo (state, orderDetailInfo) {
      state.orderCustomerInfo = { ...orderDetailInfo };
    },
    setFilterInput (state, filterParams) {
      state.filterInput = { ...filterParams };
    },
    setOrderDetailContentInput (state, input) {
      state.orderDetailContentInput = { ...input };
    },
    setOrderId (state, id) {
      state.orderId = id;
      state.setOrderId = id;
    },
    setClientGroupInput (state, id) {
      state.clientGroupInput = id;
    },
    setDeliveryDestinationInput (state, id) {
      state.deliveryDestinationInput = id;
    },
    setParentOrderIdInput (state, id) {
      state.parentOrderIdInput = id;
    },
    isFiltered (state, filter) {
      state.filter = filter;
    },
    setStatusInput (state, input) {
      state.statusInput = input;
    },
    setCustomFields (state, customFields) {
      state.customFields = customFields;
    },
    setItemSettings (state, itemSettings) {
      state.itemSettings = itemSettings;
    },
    init (state) {
      Object.keys(defaultState).map(key => {
        if (key === "managedFamilyPersist") {
          defaultState[key] = null;
          return;
        }
        if (typeof defaultState[key] === "object" && defaultState[key] !== null) {
          if (key === "detailInput") {
            defaultState[key] = Object.assign({}, defaultStateMaster[key]);
            defaultState[key].attachments = [];
            return;
          }
          if (key === "customerInput") {
            defaultState[key] = Object.assign({}, customerMaster);
            return;
          }
          if (key === "customFields") {
            defaultState[key] = [];
            return;
          }
          defaultState[key] = {};
        }
      });

      Object.assign(state, defaultState);
    },
    setManagedFamilyPersist (state, payload) {
      state.managedFamilyPersist = payload
        ? {
          managedOrders: payload.managedOrders,
          managedParentOrderId: payload.managedParentOrderId,
          activeManagedOrderId: payload.activeManagedOrderId,
          tempChildOrderSeq: payload.tempChildOrderSeq,
        }
        : null;
    },
    setFavoriteVariantCharacters (state, favoriteVariantCharacters) {
      state.favoriteVariantCharacters = favoriteVariantCharacters;
    },
    setFilteredFavoriteVariantCharacters (state, filteredFavoriteVariantCharacters) {
      state.filteredFavoriteVariantCharacters = filteredFavoriteVariantCharacters;
    },
  },
  actions: {
    async loadDefaultExpectedShippingDate ({ commit }) {
      try {
        const result = await defaultExpectedShippingDateUsecase.getDefaultExpectedShippingDate();
        if (result) {
          commit("updateExpectedShippingDate", result);
          commit("updateDefaultExpectedShippingDate", result);
          return;
        }
        commit("updateDefaultExpectedShippingDate", null);
      } catch (e) {
        commit("updateDefaultExpectedShippingDate", null);
      }
    },
    resetDetailInput ({ commit }) {
      commit("updateExpectedShippingDate", null);
    },
  },
};

function createColorObject (color) {
  try {
    const colorCode = getColorCodeBasedOnColorName(color);
    const targetColors = orderOption.colorsForFront.filter(
      el => el.value === color
    );
    if (!targetColors.length) {
      return {};
    }
    const name = targetColors[0].label;
    return {
      name,
      colorCode,
    };
  } catch (err) {
    console.log(err);
    return {};
  }
}
